namespace GeniuzPOS.QRreport {
    export interface QRywcSpec1409Form {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DateBegin: Serenity.DateEditor;
        DateEnd: Serenity.DateEditor;
        SalemanId: Serenity.LookupEditor;
    }

    export class QRywcSpec1409Form extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpec1409';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpec1409Form.init)  {
                QRywcSpec1409Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;

                Q.initFormType(QRywcSpec1409Form, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DateBegin', w3,
                    'DateEnd', w3,
                    'SalemanId', w0
                ]);
            }
        }
    }
}
